import {gsap} from 'gsap';
import {bodyScroll} from '../util/helpers';
import SmoothScroll from 'smoothscroll-for-websites';

export default {
  init() {
    // JavaScript to be fired on all pages
    const linkToModal = document.querySelector('.link-to-msg-modal');
    const menuBurger = document.getElementById('navbar-burger');
    const menuMobile = document.getElementById('navbar-mobile');
    const menuMobileClose = document.querySelector('.navbar__close');
    const mapDelegates = document.getElementById('map-delegates');
    const iconMobileEnlargeMap = document.getElementById('icon-map-enlarge');
    const navWrapper = document.getElementById('nav-wrapper');
    const latestEditionModal = document.getElementById('modal-latest-edition');
    const blockLatestEdition = document.getElementById('latest-edition');
    let navMobileTL = null;
    let navItems = menuMobile ? menuMobile.querySelectorAll('.menu-item') : null;
    let oldScrollValue = 0;
    let newScrollValue = 0;
    let previousY = 0;
    let isModalLatestEventVisible = false;

    if (linkToModal) {
      // Apply attribute for opening modal
      linkToModal.dataset.toggle = 'modal';
      linkToModal.dataset.target = '#modal-infos';
      let msgInfos = localStorage.getItem('msgInfosDisplayed');

      // By default if no localStorage item found we consider as first visit, so opening the modal
      if (msgInfos === null) {
        setTimeout(function () {
          linkToModal.click();
          localStorage.setItem('msgInfosDisplayed', Date.now().toString());
        }, 1000);
      }
    }

    let scrollToTopBtn = document.getElementById('scroll-to-top');
    if (scrollToTopBtn !== null) {
      scrollToTopBtn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToTop();
      });
    }

    function scrollToTop() {
      window.scroll({top: 0, left: 0, behavior: 'smooth'});
    }

    function enlargeMapForMobile(e) {
      e.preventDefault();
      iconMobileEnlargeMap.removeEventListener('click', enlargeMapForMobile);

      bodyScroll(false);
      let image = iconMobileEnlargeMap.dataset.img;
      let lightboxMapZoomed = document.getElementById('map-zoomed');

      if (lightboxMapZoomed === null) {
        let lightboxMapZoomed = document.createElement('div');
        lightboxMapZoomed.setAttribute('id', 'map-zoomed');
        lightboxMapZoomed.innerHTML = `
        <div class="modal__icon">
          <i class="icon icon-icon-hand-click"></i>
        </div>
        <div class="modal__content">
          <img src="${image}"} alt="">
        </div>
        <div class="modal__footer">
          <a id="close-map-zoomed" href="#" class="btn btn-primary">Fermer</a>
        </div>
        `;

        lightboxMapZoomed.addEventListener('click', () => {
          lightboxMapZoomed.remove();
          bodyScroll(true);
        });

        mapDelegates.append(lightboxMapZoomed);

        gsap.fromTo(lightboxMapZoomed, {
          y: '20%',
        }, {
          y: 0,
          opacity: 1,
          duration: 1,
        });
      }
    }

    const showEventAlbumModal = () => {
      let closeModalCounterBtn = latestEditionModal.querySelector('.modal__close');

      gsap.fromTo(latestEditionModal, {
        opacity: 0,
        y: 300,
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
      });

      isModalLatestEventVisible = true;
      closeModalCounterBtn.addEventListener('click', closeEventAlbumModal);
    }

    const closeEventAlbumModal = (e) => {
      e.preventDefault();
      latestEditionModal.remove();
      isModalLatestEventVisible = false;
    }

    const hideEventAlbumModal = () => {
      gsap.to(latestEditionModal, {opacity: 0, duration: 0.5});
      isModalLatestEventVisible = false;
    }

    window.addEventListener('scroll', function () {
      let navbarHeight = document.querySelector('.navbar').offsetHeight;
      let navbarBorderBottom = document.querySelector('.banner-tricolor').offsetHeight;
      let navbarGlobalHeight = navbarHeight + navbarBorderBottom;

      newScrollValue = window.pageYOffset;
      if (window.scrollY > navbarGlobalHeight) {
        // Detect scroll direction
        // If scroll up
        if (oldScrollValue > newScrollValue) {
          gsap.set(navWrapper, {opacity: 0});
          navWrapper.classList.add('fixed-top');
          gsap.to(navWrapper, {opacity: 1, duration: 0.5});
          // add padding top to show content behind navbar
          document.body.style.paddingTop = navbarGlobalHeight + 'px';
        } else {
          navWrapper.classList.remove('fixed-top');
          gsap.to(navWrapper, {opacity: 0, duration: 0.5});
          // remove padding top from body
          document.body.style.paddingTop = '0';
        }
        oldScrollValue = newScrollValue;
      } else if (window.scrollY === 0) {
        navWrapper.classList.remove('fixed-top');
        document.body.style.paddingTop = '0';
      } else {
        if (navWrapper.classList.contains('fixed-top')) {
          gsap.to(navWrapper, {opacity: 1, duration: 0.5});
        }
      }
    });

    // Prevent click behavior on disabled links
    let linksDisabled = document.querySelectorAll('a.disabled');
    if (linksDisabled !== null) {
      linksDisabled.forEach((links) => {
        links.addEventListener('click', (e) => {
          e.preventDefault();
        })
      });
    }

    if (navItems !== null) {
      navMobileTL = new gsap.timeline({
        paused: true,
        reversed: true,
        onStart: function () {
          bodyScroll(false);
        },
        onComplete: function () {
          let itemMapDelegates = menuMobile.querySelector('.menu-les-delegues-regionaux');
          let itemAbout = menuMobile.querySelector('.menu-a-propos');
          itemMapDelegates.addEventListener('click', () => {
            navMobileTL.reverse();
          })
          itemAbout.addEventListener('click', () => {
            navMobileTL.reverse();
            linkToModal.click();
          })
        },
        onReverseComplete: function () {
          bodyScroll(true);
        },
      });

      navMobileTL
        .fromTo(menuMobile,
          {
            opacity: 0,
            display: 'none',
            xPercent: 100,
          },
          {
            opacity: 1,
            display: 'flex',
            xPercent: 0,
            duration: 0.5,
          }
        )
        .fromTo(navItems,
          {
            opacity: 0,
            y: 0,
            x: 100,
          },
          {
            y: 0,
            x: 0,
            duration: 0.3,
            opacity: 1,
            stagger: 0.1,
            ease: 'custom',
          }
        );
    }

    const initListener = () => {
      if (menuMobileClose !== null && menuBurger !== null) {
        menuMobileClose.addEventListener('click', () => {
          navMobileTL.reversed() ? navMobileTL.play() : navMobileTL.reverse();
        })
        menuBurger.addEventListener('click', () => {
          navMobileTL.reversed() ? navMobileTL.play() : navMobileTL.reverse();
        })
      }
      if ((mapDelegates !== null) && (iconMobileEnlargeMap !== null)) {
        iconMobileEnlargeMap.addEventListener('click', enlargeMapForMobile, true);
      }
    }

    const initObserver = () => {
      if (latestEditionModal !== null && blockLatestEdition !== null) {
        let observerBlockLastestEdition = new IntersectionObserver(function (entries) {
          const currentY = entries[0].boundingClientRect.y;

          if ((entries[0].isIntersecting === true) && isModalLatestEventVisible) {
            hideEventAlbumModal();
          } else if ((entries[0].isIntersecting === false) && !isModalLatestEventVisible) {
            if (currentY > previousY) {
              showEventAlbumModal();
            }
          }
          previousY = currentY;
        }, {threshold: [0]});
        observerBlockLastestEdition.observe(blockLatestEdition);
      }
    }

    SmoothScroll({
      // Scrolling Core
      animationTime: 900, // [ms]
      stepSize: 100, // [px]

      // Acceleration
      accelerationDelta: 50,  // 50
      accelerationMax: 3,   // 3

      // Keyboard Settings
      keyboardSupport: true,  // option
      arrowScroll: 50,    // [px]

      // Pulse (less tweakable)
      // ratio of "tail" to "acceleration"
      pulseAlgorithm: true,
      pulseScale: 4,
      pulseNormalize: 1,

      // Other
      touchpadSupport: false, // ignore touchpad by default
      fixedBackground: true,
      excluded: '',
    })

    initListener();
    initObserver();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
  ,
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js